<template>
    <div>
        <el-dialog
        class="BidDialog"
        :title="'应标文件上传'"
        :visible.sync="bidShow"
        width="840px"
        :close-on-click-modal="false"
        @close="btnEvent('0')"
        height="600px">
            <div>参与报价人员信息维护</div>
            <div style="margin-top:10px;width: 100%;">
                <el-table :data="contactsInfo" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column prop="contacts" label="选择报价人员" width="200" align="center">
                        <template slot-scope="scope">
                            <span class="number" @click="selectContant(scope)">{{scope.row.contacts}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="userCode" label="账号" width="200" align="center">
                        <template slot-scope="scope">
                            <span :style="{'color':scope.row.isNone ? '#ccc' : '#333'}">{{scope.row.userCode}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="idCard" label="身份证号" align="center">
                        <template slot-scope="scope">
                            <span :style="{'color':scope.row.isNone ? '#ccc' : '#333'}">{{scope.row.idCard}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <span>
                                <span v-if="!scope.row.isNone"
                                    class="number" @click="delMumber(scope.row, scope.$index)">删除</span>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="margin-top:26px;">应标文件</div>
            <div style="margin-top:10px;width: 100%;">
                <el-table :data="bidFileInfo" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column prop="typeName" label="文件类型" align="center">
                    </el-table-column>
                    <el-table-column prop="fileName" label="应标文件名称" align="center">
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="200">
                        <template slot-scope="scope">
                            <div style="display:flex">
                                <Upload :text="'上传'" :sizeLimit="100" :uploadDisplayType="'text'" @uploadSuccess="uploadSuccess($event,scope.row)"></Upload>
                                <span class="margin-left"><el-button size="mini" type="text" @click="actionFn(scope.row, '1')">下载</el-button></span>
                                <span class="margin-left"><el-button size="mini" type="text" @click="actionFn(scope.row, '2')">预览</el-button></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="bidSeal">确 定</el-button>
            </div>
        </el-dialog>
        <otpAdvanceDialog ref="contactadvanceDialog" @confirm="detaliSearchSure"></otpAdvanceDialog>
    </div>
</template>
<script>
import Upload from '../../../components/upload/Index.vue';
import { filePreview } from '@/utils/filePreview.js';
import otpAdvanceDialog from '@/components/lots/otpAdvanceDialog';
import { getBidFileStampInfo, delBidTenderUser, savebidResponse } from '../../../../lsrm/api/myBidding.js';
export default {
    components: { otpAdvanceDialog, Upload },
    props: {
        MDialogshow: {
            type: Boolean
        },
        rowBidDialogData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            isdisflag: false,
            saveBidFileload: false,
            dialogVisible: true,
            rowInfo: {},
            params: {
                name: '联系人',
                value: 'contacts',
                advanceLabel: '选择联系人',
                advanceConfig: [
                    { prop: 'contacts', value: '联系人名称' },
                    { prop: 'idCard', value: '身份证' },
                    { prop: 'contactsMobile', value: '手机号' },
                    { prop: 'userCode', value: '账号' }
                ],
                tableConfig: [
                    { prop: 'contacts', value: '联系人名称' },
                    { prop: 'idCard', value: '身份证' },
                    { prop: 'contactsMobile', value: '手机号' },
                    { prop: 'userCode', value: '账号' }
                ],
                advanceUrl: `/supplier/selectInfoPageByUserCodeIsNotNull?supplierCode=`,
                cbParams: ['contacts#contacts', 'idCard#idCard', 'contactsMobile#contactsMobile', 'userCode#userCode'],
                prefix: '/api-srm-web'
            },
            bidShow: false,
            rowIndex: 0,
            isNotFirstSave: true,
            contactsInfo: [{
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }, {
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }, {
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }],
            bidFileInfo: [{
                typeName: '竞标单位回执',
                type: 'BIDDER',
                fileName: '',
                fileUrl: ''
            }, {
                typeName: '投标承诺书',
                type: 'COMMITMENT',
                fileName: '',
                fileUrl: ''
            }],
            userIdlist: [],
            moduleNo: '',
            resetSave: false // 重新保存联系人标记
        };
    },
    mounted() {},
    methods: {
        uploadSuccess(res, row) {
            this.bidFileInfo.forEach(element => {
                if (element.type === row.type) {
                    element.fileName = res.data.data.localFileName;
                    element.fileUrl = res.data.data.downUrl;
                    element.fileId = res.data.data.id;
                }
            });
        },
        delMumber(row, index) {
            if (row.id) {
                delBidTenderUser(row.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功！');
                        this.resetSave = true;
                        this.contactsInfo[index] = {
                            contacts: '选择联系人',
                            userCode: '选择联系人自动带出',
                            idCard: '选择联系人自动带出',
                            isNone: true,
                            contactsMobile: ''
                        };
                        this.contactsInfo = [...this.contactsInfo];
                        let flag = false;
                        const userIdlist = [];
                        this.contactsInfo.map((el, i) => {
                            if (el.id) {
                                flag = true;
                                userIdlist.push({
                                    id: el.id
                                });
                            }
                        });
                        if (!flag) {
                            this.isNotFirstSave = false;
                        }
                        this.userIdlist = userIdlist;
                    }
                });
            } else {
                this.$message.success('删除成功！');
                this.contactsInfo[index] = {
                    contacts: '选择联系人',
                    userCode: '选择联系人自动带出',
                    idCard: '选择联系人自动带出',
                    isNone: true,
                    contactsMobile: ''
                };
                this.contactsInfo = [...this.contactsInfo];
            }
        },
        bidModuleFilesFunc() {
            return this.bidFileInfo.map(el => {
                return {
                    fileName: el.fileName,
                    fileUrl: el.fileUrl,
                    fileId: el.fileId,
                    moduleType: el.type === 'BIDDER' ? '4' : '3'
                };
            });
        },
        bidSeal() {
            const arr = this.checkmemberFunc();
            if (!arr) return;
            const enclosureFlag = this.enclosureVeri();
            if (enclosureFlag) return;
            this.$confirm('请确认报价人员跟线下提供的报价人员是否一致，是否手工上传应标文件，一旦确定，则供应商应标状态更新为应标成功，信息则无法再修改！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const par = {
                    bidTenderUsers: arr,
                    bidModuleFiles: this.bidModuleFilesFunc(),
                    bidNo: this.rowInfo.bidNo,
                    supplierCode: this.rowInfo.supplierCode
                };
                savebidResponse(par).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('上传成功！');
                        this.bidShow = false;
                        this.resetData();
                        this.$emit('mdialogFn');
                    }
                });
            });
        },
        enclosureVeri() {
            let BIDDER_VERI = true;
            let COMMITMENT_VERI = true;
            this.bidFileInfo.forEach(el => {
                if (el.type === 'BIDDER' && !el.fileName) {
                    BIDDER_VERI = false;
                }
                if (el.type === 'COMMITMENT' && !el.fileName) {
                    COMMITMENT_VERI = false;
                }
            });
            if (!BIDDER_VERI) {
                this.$message.warning('请上传竞标单位回执！');
                return true;
            }
            if (!COMMITMENT_VERI) {
                this.$message.warning('请上传投标承诺书！');
                return true;
            }
            return false;
        },
        actionFn(row, type, index) {
            if (type === '1') {
                window.open(row.fileUrl, '_parent');
            } else {
                filePreview(row);
            }
        },
        detaliSearchSure(res) {
            const flag = this.contactsInfo.find(el => {
                return el.idCard === res.idCard;
            });
            if (flag) {
                this.$message.warning('联系人已选择，请重新选择其他联系！');
                return;
            }
            this.resetSave = true;
            res.isNone = false;
            this.contactsInfo[this.rowIndex] = res;
            this.contactsInfo = [...this.contactsInfo];
        },
        loadData(data) {
            this.resetData();
            this.moduleNo = data.moduleNo;
            // this.bidFileInfo = data.bidModuleFiles;
            this.isNotFirstSave = data.bidTenderUsers.length > 0;
            const userIdlist = data.bidTenderUsers.map((el, i) => {
                this.contactsInfo[i] = {
                    contacts: el.tenderUserName,
                    userCode: el.tenderUserCode,
                    idCard: el.idCard,
                    isNone: false,
                    contactsMobile: el.contactNumber,
                    id: el.id ? el.id : null
                };
                return {
                    id: el.id
                };
            });
            this.userIdlist = userIdlist;
            this.contactsInfo = [...this.contactsInfo];
        },
        getInfo() {
            const par = {
                'id': this.rowInfo.id,
                'supplierCode': this.rowInfo.supplierCode
            };
            getBidFileStampInfo(par).then(res => {
                if (res && +res.code === 0) {
                    const data = res.data.data || {};
                    if (JSON.stringify(data) === '{}') {
                        this.isNotFirstSave = false;
                    } else {
                        this.loadData(data);
                    }
                }
            });
        },
        selectContant(row) {
            // if (this.rowInfo.supplierBidStatus === '5' || this.rowInfo.supplierBidStatus === '6') {
            this.rowIndex = row.$index;
            const current = this.params;
            const advanceCascade = {};
            if (current.advanceCascade && Object.prototype.toString.call(current.advanceCascade) === '[object String]') {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.formData[sourceProp];
                });
            }
            this.$refs.contactadvanceDialog.show(true, current, advanceCascade);
            // }
        },
        checkmemberFunc() {
            const contInfo = [...this.contactsInfo];
            let idCardNull = false;
            const arr = [];
            contInfo.map(el => {
                if (!el.isNone) {
                    if (!el.idCard) {
                        idCardNull = true;
                    }
                    arr.push({
                        tenderUserName: el.contacts,
                        tenderUserCode: el.userCode,
                        contactNumber: el.contactsMobile,
                        supplierName: this.rowInfo.supplierName,
                        supplierCode: this.rowInfo.supplierCode,
                        bidNo: this.rowInfo.bidNo,
                        bidName: this.rowInfo.bidName,
                        idCard: el.idCard
                    });
                }
            });
            if (arr.length === 0) {
                this.$message.warning('请选择联系人');
                this.saveBidFileload = false;
                return false;
            }
            if (idCardNull) {
                this.$message.warning('身份证不能为空！');
                this.saveBidFileload = false;
                return false;
            }
            return arr;
        },
        btnEvent(type) {
            this.bidShow = false;
            this.resetData();
            this.$emit('mdialogFn');
        },
        resetData() {
            this.contactsInfo = [{
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }, {
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }, {
                contacts: '选择联系人',
                userCode: '选择联系人自动带出',
                idCard: '选择联系人自动带出',
                isNone: true,
                contactsMobile: ''
            }];
            this.bidFileInfo = [{
                typeName: '竞标单位回执',
                type: 'BIDDER',
                fileName: '',
                fileUrl: ''
            }, {
                typeName: '投标承诺书',
                type: 'COMMITMENT',
                fileName: '',
                fileUrl: ''
            }];
        }
    },
    watch: {
        MDialogshow(val) {
            this.bidShow = val;
        },
        rowBidDialogData: {
            handler(val, oldval) {
                if (JSON.stringify(val) !== '{}') {
                    this.rowInfo = val;
                    this.params.advanceUrl = `/supplier/selectInfoPageByUserCodeIsNotNull?supplierCode=${val.supplierCode}`;
                    this.getInfo(); // 获取盖章联系人和盖章文件列表接口
                }
            },
            deep: true
        }

    }
};
</script>
<style lang="less">
.BidDialog {
    .number {
        color: #00BCBF;
        cursor: pointer;
    }
    .info {
        font-size: 16px;
        font-weight: 700;
        color: #333;
    }
    .el-table__row {
        font-size: 12px;
    }
    .margin-left {
        margin-left: 10px;
    }
    .el-upload {
        color: #00BCBF;
    }
}
</style>